import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Stormpath, defaultSpTokenResolver } from '../stormpath/stormpath.service';
export var EmailVerificationComponent = (function () {
    function EmailVerificationComponent(stormpath, location) {
        this.stormpath = stormpath;
        this.location = location;
    }
    EmailVerificationComponent.prototype.ngOnInit = function () {
        this.verifying = false;
        this.verified = false;
        this.verificationFailed = false;
        this.sptoken = this.spTokenResolver();
        if (this.sptoken) {
            this.verify();
        }
    };
    EmailVerificationComponent.prototype.spTokenResolver = function () {
        return defaultSpTokenResolver(this.location);
    };
    EmailVerificationComponent.prototype.verify = function () {
        var _this = this;
        this.verifying = true;
        this.stormpath.verifyEmailVerificationToken(this.sptoken)
            .subscribe(function () {
            _this.verifying = false;
            _this.verified = true;
        }, function (error) {
            _this.verifying = false;
            if (error.status && error.status === 404) {
                _this.verificationFailed = true;
            }
            else {
                _this.error = error.message;
            }
        });
    };
    EmailVerificationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'email-verification',
                    template: "<template #defaultTemplate>\n<div class=\"row\">\n  <div class=\"col-sm-offset-4 col-xs-12 col-sm-4\">\n    <p *ngIf=\"verifying\" class=\"alert alert-warning\">We are verifying your account</p>\n    <p *ngIf=\"verified\" class=\"alert alert-success\">\n      Your account has has been verified!  You may now login.\n    </p>\n    <div *ngIf=\"verificationFailed\" class=\"alert alert-danger\">\n      This email verification link is not valid.  Please request a new email verification link.\n    </div>\n    <p class=\"text-danger\" *ngIf=\"error\">{{error}}</p>\n  </div>\n</div>\n</template>\n<template\n  [ngTemplateOutlet]=\"customTemplate || defaultTemplate\">\n</template>"
                },] },
        { type: Injectable },
    ];
    /** @nocollapse */
    EmailVerificationComponent.ctorParameters = function () { return [
        { type: Stormpath, },
        { type: Location, },
    ]; };
    EmailVerificationComponent.propDecorators = {
        'customTemplate': [{ type: Input },],
    };
    return EmailVerificationComponent;
}());
//# sourceMappingURL=email-verification.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/email-verification/email-verification.component.js
// module id = 567
// module chunks = 0